export class stockStatementsModel {
cstmInvestorId : any;
setValue(res){
if(res){
if(res['cstmInvestorId']){this.cstmInvestorId = res['cstmInvestorId'];}
}
}
}